import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const ClientTestimonial = ({ testimonial }) => {
    const { content, logo, personName, position } = testimonial || {}
    return (
        <section>
            <div className="w-full container">
                <div className="text-center">
                    {logo?.localFile ? (
                        <GatsbyImage
                            objectFit="contain"
                            height={56}
                            image={getImage(logo?.localFile?.childImageSharp)}
                            alt={logo?.altText}
                            className={'mb-4 !inline-block !h-14'}
                        />
                    ) : (
                        <img
                            objectFit="contain"
                            height={56}
                            src={logo?.sourceUrl}
                            alt={logo?.altText}
                            className={
                                'mb-4 !inline-block !h-14 object-contain'
                            }
                        />
                    )}

                    {content && (
                        <p className="text-xl max-w-5xl block mx-auto xl:pl-8">
                            <span className="text-6xl font-bold mr-2 inline-block translate-y-6 leading-[0px]">
                                “
                            </span>
                            {content}
                            <span className="text-6xl font-bold inline-block ml-1 -translate-y-2 leading-[0px]">
                                ,,
                            </span>
                        </p>
                    )}
                </div>

                <div className="mt-7 flex lg:justify-center lg:flex-row gap-y-4 lg:gap-x-5 flex-col items-center">
                    <div className="text-center">
                        <div className="h-[1px] w-1/2 bg-black/30 mx-auto mb-7"></div>

                        {personName && (
                            <strong className="my-2 text-balance xl:mt-0 block leading-[14px]">
                                {personName}
                            </strong>
                        )}

                        {position && (
                            <p className="block leading-none">{position}</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ClientTestimonial
